module.exports = __webpack_public_path__ + "img/id-wrong-blackwhite.165b40de.png";